import { HeroSection } from '../components/landing/HeroSection';
import { SocialProofBar } from '../components/landing/SocialProofBar';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { FeatureSection } from '../components/landing/FeatureSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { PricingPreviewSection } from '../components/landing/PricingPreviewSection';
import { SiteFooter } from '../components/landing/SiteFooter';

export default function LandingPage() {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <HeroSection />
      <SocialProofBar />
      <HowItWorksSection />
      <FeatureSection />
      <TestimonialsSection />
      <PricingPreviewSection />
      <SiteFooter />
    </div>
  );
}
